import { render } from "./LtIcon.vue?vue&type=template&id=6b7268e9"
import script from "./LtIcon.vue?vue&type=script&lang=js"
export * from "./LtIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__